import React from "react";
import { Typography, Button, Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import LoginContainer from "../LoginContainer";
import BackButtonLogin from "../../commons/BackButtonLogin";

const style = {
    paper: {
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        marginLeft: "25px"
    },
    form: {
        width: "100%",
        marginTop: 20,
        textAlign: "center"
    },
    password: {
        width: "292px"
    },
    submit: {
        textTransform: "none",
        width: "292px",
        align: "center"
    },
    leftside: {
        backgroundColor: "#004B93",
        width: "100%",
        height: "100%",
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        align: "center",
    },
    error: {
        "&.MuiFormHelperText-root.Mui-error": {
            color: "red"
        }
    },
    titleOne: {
        marginTop: "60px",
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "22px",
        lineHeight: "19px",
        textAlign: "center",
        color: "#013F8C"
    },
    titleTwo: {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.05px",
        color: "#9EA0A5",
        paddingTop: "26px",
        textAlign: "center",
        margin: "auto",
        width: "305px"
    }
};

const Success = (props) => {
    const tryAgainBtn = (e) => {
        e.preventDefault();
        props.history.push("/auth/recuperar");
    };

    const uppsComponent = () => (
        <Grid container spacing={0}>
                <Grid>
                    <div style={style.paper}>
                        <Typography>
                            <BackButtonLogin to={'/auth/recuperar'}/>
                        </Typography>
                        <Typography style={style.titleOne}>
                            Upps...
                        </Typography>

                        <img alt="nurse" src="/static/upps.png" style={{ width: '47%', height: 'auto', margin: "auto" }} />
                        <Typography
                            style={style.titleTwo}
                        >
                            El correo no ha podido ser enviado,<br />
                            inténtalo más tarde.
                        </Typography>
                        <form style={style.form}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                style={style.submit}
                                onClick={tryAgainBtn}
                            >
                                INTENTAR DE NUEVO
                            </Button>
                        </form>
                    </div>
                </Grid>
            </Grid>
    )

    return (
        <LoginContainer>
            {uppsComponent()}
        </LoginContainer>
    );
};

export default withRouter(Success);
